import { ApiProperty } from "@nestjs/swagger";

export class GrnInvoiceNumberRequest{
    invoiceNumber:string;
    constructor(invoiceNumber:string){
        this.invoiceNumber = invoiceNumber
    }
}